const GET_NETWORK = 'GET_NETWORK' as const;

export default {
  GET_NETWORK,
};
